/*
 * @Author: your name
 * @Date: 2020-01-13 15:56:22
 * @LastEditTime : 2020-01-15 10:13:01
 * @LastEditors  : Please set LastEditors
 * @Description: api接口
 * @FilePath: /wx_website/src/apis/index.ts
 */
import request from "@/utils/request";
import md5 from "blueimp-md5";

//省市区
export function regionList(params: object) {
  return request({
    url: "/v1/common/region_list",
    method: "get",
    params
  });
}

//新闻动态列表
export function newsList(params: object) {
  return request({
    url: "/v1/official/news/list",
    method: "get",
    params
  });
}

//新闻动态详情
export function newsDetail(params: object) {
  return request({
    url: "/v1/official/news/info",
    method: "get",
    params
  });
}

export function commentSave(data: object) {
  return request({
    url: "/v1/official/news/comment/save",
    method: "post",
    data
  });
}

//合作案例列表
export function caseList() {
  return request({
    url: "/v1/official/case/list",
    method: "get"
  });
}

//banner列表
export function bannerList() {
  return request({
    url: "v1/official/banner/list",
    method: "get"
  });
}

//友情链接列表
export function linkList() {
  return request({
    url: "/v1/official/link/list",
    method: "get"
  });
}

//问题列表
export function quesList() {
  return request({
    url: "/v1/official/question/type",
    method: "get"
  });
}

//问题内容
export function questionContent(params: object) {
  return request({
    url: "/v1/official/question/list",
    method: "get",
    params
  });
}

//保存企业咨询
export function orgSave(data: object) {
  return request({
    url: "/v1/official/advice/organization/save",
    method: "post",
    data
  });
}
//保存代理咨询
export function agentSave(data: object) {
  return request({
    url: "/v1/official/advice/agent/save",
    method: "post",
    data
  });
}

//登录
export function login(data: object) {
  return request({
    url: "/v1/user/auth/login",
    method: "post",
    data
  });
}
//登录
export function getOrgs() {
  return request({
    url: "/v1/user/info/organizations",
    method: "get"
  });
}

/**
 * 获取uuid(二维码登陆)
 */
export function getUUID() {
  const timestamp = Math.round(+new Date() / 1000);
  const randomStr = 100000000000 + Math.floor(Math.random() * 100000000000);
  return request({
    url: "/v1/user/auth/get_uuid",
    method: "post",
    data: {
      timestamp,
      random_str: randomStr,
      sign: md5("web" + randomStr + timestamp)
    }
  });
}
interface GetCodeRequest {
  mobile: string;
  timestamp: number;
  sign: string;
}

/**
 * 获取手机验证码
 */
export function getCode(mobile: string) {
  const timestamp = Math.round(+new Date() / 1000);
  const params: GetCodeRequest = {
    mobile,
    timestamp,
    sign: md5(mobile + "ee7aebd9fd5047b4a35655c93561c6c04" + timestamp)
  };

  return request({
    url: "v1/user/auth/get_code",
    method: "get",
    params
  });
}
/**
 * 二维码登陆验证
 */
export function uuidLogin(uuid: string) {
  const timestamp = Math.round(+new Date() / 1000);
  return request({
    url: "v1/user/auth/login_uuid",
    method: "post",
    data: {
      timestamp,
      uuid
    }
  });
}
